var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { useCollapseContext } from '.';
export function useCollapse(props) {
    var _a = props.defaultExpanded, defaultExpanded = _a === void 0 ? true : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, _c = props.card, card = _c === void 0 ? false : _c, title = props.title;
    var _d = useState(defaultExpanded), expanded = _d[0], setExpanded = _d[1];
    try {
        var state_1 = useCollapseContext().state;
        useEffect(function () {
            if (expanded) {
                state_1.setExpandedTarget(title || '');
            }
        }, [expanded]);
        useEffect(function () {
            if (state_1.expandedTarget !== title) {
                setExpanded(false);
            }
        }, [state_1.expandedTarget]);
    }
    catch (err) {
        // 에러 아님
    }
    return __assign(__assign({}, props), { title: title, defaultExpanded: defaultExpanded, size: size, card: card, expanded: expanded, fold: fold });
    function fold() {
        setExpanded(function (flag) { return !flag; });
    }
}
//# sourceMappingURL=useCollapse.js.map